/**
 * package: com.inq.utils
 * class: ConsoleLogger
 * root Object
 * @constructor
 */
com.inq.utils.ConsoleLogger = function() {};
$hxClasses['com.inq.utils.ConsoleLogger'] = com.inq.utils.ConsoleLogger;
/** @private @type {Array} */
com.inq.utils.ConsoleLogger.__name__ = ["com","inq","utils","ConsoleLogger"];

com.inq.utils.ConsoleLogger.detect = (!com.inq.flash.client.control.FlashPeer.isLoggingDisabled() ? function () {

	// N.B. "try-catch" should be avoided in hot code when possible, as it slows down JS in Google Chrome.

	// The check of "window.console" should NOT be cached,
	// because in IE, window.console can be created at any moment: it is undefined until a visitor opens the DevTools.
	return !!window.console;
} : function () {
	return false;
});


/**
 * redirectTraces
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function redirectTraces()
 * @public
 * @static
 * @return {void}
 */
com.inq.utils.ConsoleLogger.redirectTraces = function() {
	haxe.Log.trace = com.inq.utils.ConsoleLogger.trace;
	js.Lib.onerror = com.inq.utils.ConsoleLogger.onError;
};


/**
 * onError
 *
 * $type TFun([{ name => err, t => TInst(String,[]), opt => false },{ name => stack, t => TInst(Array,[TInst(String,[])]), opt => false }],TEnum(Bool,[]))
 * public static function onError( err : String, stack : Array<String> )
 * @public
 * @static
 * @param {string}  err 
 * @param {Array}  stack 
 * @return {boolean}
 */
com.inq.utils.ConsoleLogger.onError = function(err,stack) {
	/** @type {string} */
	var buf = err + "\n";
	var /** @type {number} */ _g = 0;
	while(_g < stack.length) {
		var /** @type {string} */ s = stack[_g];
		++_g;
		buf += "Called from " + s + "\n";
	}
	com.inq.utils.ConsoleLogger.trace(buf,null);
	return true;
};


/**
 * trace
 *
 * @public
 * @static
 * @param {string} v - log message
 * @param {Object=} inf - additional logging information
 * @return {void}
 */
com.inq.utils.ConsoleLogger.trace = function(v,inf) {
	if (!com.inq.utils.ConsoleLogger.detect()) {
		return;
	}
	/** @type {?string} */
	var type = inf != null && inf.customParams != null ? inf.customParams[0] : null;
	if (type != "warn" && type != "info" && type != "debug" && type != "error") {
		type = inf == null ? "error" : "log";
	}
	
	if (null != window.console[type]) {
		try {
			/** @type {string} */
			var place = inf == null ? ""
				: (inf.fileName || inf.className) + ":"
				 +(inf.lineNumber || inf.methodName) + " : ";
			window.console[type](place + Std.string(v));
		} catch (e) {
		}
	}
};

/** @type {com.inq.utils.ConsoleLogger} */
com.inq.utils.ConsoleLogger.prototype.__class__ = com.inq.utils.ConsoleLogger;
